// @flow
import { handleResponseOld, makeGet, makePost } from './helpers';

type FetchSavedSearchesParams = {
    authToken: string,
    deployment: string,
};

type FetchSavedSearchItemsParams = {
    authToken: string,
    deployment: string,
    filter: string,
    page: number,
    pageSize: number,
    sort: string,
};

type PostDeleteSavedSearchParams = {
    authToken: string,
    deployment: string,
    savedSearchId: any,
};

type PostIsSavedSearchParams = {
    authToken: string,
    deployment: string,
    ssParams: any,
};

type PostSaveSearchParams = {
    authToken: string,
    deployment: string,
    sendAlert: boolean,
    ssParams: any,
};

type PostSubscribeToSavedSearchParams = {
    authToken: string,
    deployment: string,
    savedSearchId: any,
};

type PostUnsubscribeFromSavedSearchParams = {
    authToken: string,
    deployment: string,
    savedSearchId: any,
};

type DeleteSavedSearchUrlParams = {
    deployment: string,
    savedSearchId: any,
    signature: string,
};

export default {
    deleteSavedSearchUrl: ({ deployment, savedSearchId, signature }: DeleteSavedSearchUrlParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'deletesavedsearchurl',
                deployment,
                path: '<SAVED-SEARCH-API>',
                useCacheKey: false,
            });
            request.send({ action: 'deleteSavedSearch', savedSearchId: Number(savedSearchId), signature });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchSavedSearches: ({ authToken, deployment }: FetchSavedSearchesParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ authToken, deployment, path: '<ITEM-API>savedsearch/facets' });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchSavedSearchItems: ({ authToken, deployment, filter, page, pageSize, sort }: FetchSavedSearchItemsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ authToken, deployment, path: '<SAVED-SEARCH-API>getsavedsearchitems' });
            request.query({ filter, page, pageSize, sort });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postDeleteSavedSearch: ({ authToken, deployment, savedSearchId }: PostDeleteSavedSearchParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'deletesavedsearch',
                authToken,
                deployment,
                path: '<LEGACY-SAVED-SEARCH-API>',
                useCacheKey: false,
            });
            request.send({ savedSearchId });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postIsSavedSearch: ({ authToken, deployment, ssParams }: PostIsSavedSearchParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'getsearchsaved',
                authToken,
                deployment,
                path: '<LEGACY-SAVED-SEARCH-API>',
                useCacheKey: false,
            });
            request.send({ facets: ssParams });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postSaveSearch: ({ authToken, deployment, sendAlert, ssParams }: PostSaveSearchParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'savesearch',
                authToken,
                deployment,
                path: '<LEGACY-SAVED-SEARCH-API>',
                useCacheKey: false,
            });
            request.send({ facets: ssParams, sendAlert });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postSubscribeToSavedSearch: ({ authToken, deployment, savedSearchId }: PostSubscribeToSavedSearchParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'subscribesavedsearch',
                authToken,
                deployment,
                path: '<LEGACY-SAVED-SEARCH-API>',
                useCacheKey: false,
            });
            request.send({ savedSearchId, sendAlert: true });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postUnsubscribeFromSavedSearch: ({ authToken, deployment, savedSearchId }: PostUnsubscribeFromSavedSearchParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'subscribesavedsearch',
                authToken,
                deployment,
                path: '<LEGACY-SAVED-SEARCH-API>',
                useCacheKey: false,
            });
            request.send({ savedSearchId, sendAlert: false });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
